import { render, staticRenderFns } from "./ShipmentPrintKkV1.vue?vue&type=template&id=70639e6c&scoped=true&"
import script from "./ShipmentPrintKkV1.vue?vue&type=script&lang=js&"
export * from "./ShipmentPrintKkV1.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentPrintKkV1.vue?vue&type=style&index=0&id=70639e6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70639e6c",
  null
  
)

export default component.exports